import React from "react";
import CustomEditButton from "@/common/components/custom/buttons/CustomEditButton";
import { ButtonWrapper } from "../../../AdminCommandPage.styled";
import { WIZARD_STEP } from "../constants";
import { Hint } from "../AddLanguageWizard.styled";
import TargetLanguageLabel from "./TargetLanguageLabel";

const StepMarkWords = ({
  targetLanguage,
  setStep,
  handleMarkWordsAsUser,
  handleClose,
}) => (
  <>
    <TargetLanguageLabel language={targetLanguage} />
    <Hint>
      Marks imported core words as uploaded/verified by the current user.
    </Hint>
    <ButtonWrapper>
      <CustomEditButton
        text="Back"
        onClick={() => setStep(WIZARD_STEP.IMPORT_DATABASE)}
      />
      <CustomEditButton
        text="Mark words as user"
        onClick={handleMarkWordsAsUser}
      />
      <CustomEditButton text="Close" onClick={handleClose} />
    </ButtonWrapper>
  </>
);

export default StepMarkWords;
